import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import Wrapper from './style';

const Button = (props) => {
  const { onClick } = props;

  return (
    <Wrapper aria-hidden="true" onClick={onClick}>
      <EditOutlined />
    </Wrapper>
  );
};

export default Button;
